import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Loader2, Save } from 'lucide-react';
import { inventoryTemplatesAPI } from '../lib/api';
import { toast } from 'sonner';

export const SaveTemplateModal = ({ open, onClose, vehicleId, vehicleName, inventoryCount }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error('Template name is required');
      return;
    }
    setSaving(true);
    try {
      const res = await inventoryTemplatesAPI.create({
        vehicle_id: vehicleId,
        name: name.trim(),
        description: description.trim() || null,
      });
      toast.success(`Template "${res.data.name}" saved with ${res.data.item_count} items`);
      setName('');
      setDescription('');
      onClose(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to save template');
    } finally {
      setSaving(false);
    }
  };

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      setName('');
      setDescription('');
      onClose(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="save-template-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Save className="w-5 h-5" />
            Save Inventory as Template
          </DialogTitle>
          <DialogDescription>
            Save the current inventory of <strong>{vehicleName}</strong> ({inventoryCount} items) as a reusable template.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div className="space-y-2">
            <Label className="text-sm font-bold uppercase tracking-wide">Template Name *</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. HVAC Tech Standard Load"
              className="h-11"
              autoFocus
              data-testid="template-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-bold uppercase tracking-wide">Description</Label>
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional description for this template"
              rows={2}
              className="resize-none"
              data-testid="template-description-input"
            />
          </div>

          <Button
            className="w-full h-11 font-bold"
            onClick={handleSave}
            disabled={saving || !name.trim()}
            data-testid="save-template-submit-btn"
          >
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
            Save Template
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
